import BusinessReturnList from '@/components/BusinessReturn/BusinessReturnList'
import BusinessReturnForm from '@/components/BusinessReturn/BusinessReturnForm'
import BusinessReturnDetail from '@/components/BusinessReturn/BusinessReturnDetail'

let BusinessReturnRouter = [{
  path: '/business_return',
  name: 'BusinessReturnList',
  component: BusinessReturnList,
  meta: {
    title: 'Demandes de retour',
    requiresAuth: true,
    authorizations: ['business-return_index', 'desktop_access']
  }
}, {
  path: '/business_return/status/:status',
  name: 'BusinessReturnListByStatus',
  component: BusinessReturnList,
  meta: {
    title: 'Demandes de retour',
    requiresAuth: true,
    authorizations: ['business-return_index', 'desktop_access']
  }
}, {
  path: '/business_return/new',
  name: 'BusinessReturnNew',
  component: BusinessReturnForm,
  meta: {
    title: 'Nouvelle demande de retour',
    requiresAuth: true,
    authorizations: ['business_return_new', 'desktop_access']
  }
}, {
  path: '/business_return/:id/edit',
  name: 'BusinessReturnEdit',
  component: BusinessReturnForm,
  meta: {
    title: 'Modifier une demande de retour',
    requiresAuth: true,
    authorizations: ['business-return_edit', 'desktop_access']
  }
}, {
  path: '/business_return/:id',
  name: 'BusinessReturnDetail',
  component: BusinessReturnDetail,
  meta: {
    title: 'Fiche demande de retour',
    requiresAuth: true,
    authorizations: ['business-return_show', 'desktop_access']
  }
}]

export default BusinessReturnRouter



// WEBPACK FOOTER //
// ./src/components/BusinessReturn/router.js